class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (this.classList.contains('active')) return;
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true },
    );

    document.body.classList.add('overflow-hidden');

    // cart-drawer-items is a CartItems subclass that extends createViewEventElement.
    // Its `view-event-trigger="manual"` skips auto-dispatch on connect; we fire
    // it here when the drawer opens, with `context: 'dialog'` from the payload attribute.
    this.querySelector('cart-drawer-items')?.dispatchViewEvent();
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

if (!customElements.get('cotoli-cart-recommendations')) {
 customElements.define('cotoli-cart-recommendations',class extends HTMLElement {
 async connectedCallback(){
 if(this.dataset.loaded)return;
 this.dataset.loaded='true';
 try{
 const response=await fetch(this.dataset.url);
 if(!response.ok)return;
 const html=new DOMParser().parseFromString(await response.text(),'text/html');
 const content=html.querySelector('[data-cotoli-recommendations-content]');
 if(!this.isConnected||!content?.querySelector('.cotoli-rec-card'))return;
 this.innerHTML=content.innerHTML;this.hidden=false;
 this.addEventListener('change',event=>{
 event.stopPropagation();
 const card=event.target.closest('.cotoli-rec-card');
 if(!card)return;
 card.querySelector('button').disabled=!event.target.value;
 const option=event.target.selectedOptions[0];
 if(option?.dataset.price)card.querySelector('.cotoli-rec-price').textContent=option.dataset.price;
 });
 this.addEventListener('click',async event=>{
 const button=event.target.closest('button');
 if(!button||button.disabled)return;
 event.preventDefault();
 const select=button.closest('.cotoli-rec-card').querySelector('select');
 if(!select.value||this.dataset.busy)return;
 this.dataset.busy='true';
 this.querySelectorAll('button').forEach(item=>item.disabled=true);
 const status=this.querySelector('[role="status"]');status.textContent='';
 try{
 const drawer=document.querySelector('cart-drawer');
 const response=await fetch(window.routes.cart_add_url,{
 method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
 body:JSON.stringify({items:[{id:Number(select.value),quantity:1}],sections:drawer.getSectionsToRender().map(item=>item.id),sections_url:window.location.pathname})
 });
 const data=await response.json();
 if(!response.ok||data.status)throw new Error(data.description||status.dataset.error);
 if(!data.sections?.['cart-drawer']){window.location.reload();return;}
 drawer.renderContents(data);
 requestAnimationFrame(()=>drawer.querySelector('.cotoli-rec-heading')?.focus());
 }catch(error){
 status.textContent=error.message||status.dataset.error;
 this.querySelectorAll('.cotoli-rec-card').forEach(card=>card.querySelector('button').disabled=!card.querySelector('select').value);
 }finally{delete this.dataset.busy;}
 });
 }catch(error){this.hidden=true;}
 }
 });
}
